export default "__VITE_ASSET__a8cbeb90__"